import { render } from "./as-number.vue?vue&type=template&id=b7a4fbc6&scoped=true&ts=true"
import script from "./as-number.vue?vue&type=script&lang=ts"
export * from "./as-number.vue?vue&type=script&lang=ts"

import "./as-number.vue?vue&type=style&index=0&id=b7a4fbc6&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a4fbc6"]])

export default __exports__